import { AxiosInstance } from 'axios';
import StateService from './stateService';

export default function useState( axiosIns: AxiosInstance, stateOverrideConfig: Object ) {
  const state = new StateService( axiosIns, stateOverrideConfig );

  return {
    state,
  }
}